import React from 'react';

export default class EventNotifications extends React.Component {
  static defaultProps = {
    retryInterval: 2000,
  };

  constructor(props) {
    super(props);
    this.boundNotify = (event, data) => this.notify(event, data);
  }

  componentDidMount() {
    this.tryBindEvents();
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
    if (window.watsonViewer) {
      this.props.events.forEach(e => {
        window.watsonViewer.unbind(e, this.boundNotify);
      });
    }
  }

  // TODO: Probably better to replace with an always-present event dispatcher that mediates contact with the viewer
  tryBindEvents() {
    if (window.watsonViewer) {
      this.props.events.forEach(e => {
        window.watsonViewer.bind(e, this.boundNotify);
      });
    } else {
      this.timeoutId = setTimeout(
        () => this.tryBindEvents(),
        this.props.retryInterval
      );
    }
  }

  notify(event, data) {
    if (this.props.onJigsawEvent) {
      this.props.onJigsawEvent(event, data);
    }
  }

  render() {
    return null;
  }
}
